import { FounderQuote } from "@/components/FounderQuote";

export const ZeroTrustDmarcFounderQuote = () => {
  return (
    <FounderQuote
      quote="The shift to strict DMARC alignment caught many organizations off-guard. We've been advising clients for years: treat email authentication like you treat network security—zero trust by default. In 2026, that advice became mandatory. If your DMARC policy isn't at p=reject, you're not compliant."
      author="aman"
      tagline="Implementing zero-trust email for enterprise clients since 2020"
    />
  );
};